import Vue from 'vue'
import Vuex from 'vuex'

export default class {
  constructor() {
    Vue.use(Vuex);
    const state = {};
    const getters = {};
    const mutations = {};
    const actions = {};

    this.store = new Vuex.Store({
      state: {
        selectedPageIndex: 0,
        searchQuery: {
          searchTerm: "",
          facets: [],
          filters: [],
          currentPage: 0,
          pageSize: 20,
          searchIndex: "",
          filterGroups: "",
          showContentType: false
        },
        results: {
          queryUsed: {},
          itemResults: [],
          filters: [],
          totalResultCount: 0,
          currentPage: 0,
          pageSize: 0,
          totalPages: 0
        },
        settings: {
          searchUrl: "",
          headerText: "Search Results",
          searchPlaceholder: "Search...",
          searchButtonText: "Search",
          filterText: "Refine Results",
          filterButtonText: "Apply Filters"
        }
      },
      getters,
      mutations: {
        setQuery(state, searchTerm) {
          state.searchQuery.searchTerm = searchTerm;
        },
        setCurrentPage(state, data) {
          state.searchQuery.currentPage = data;
        },
        setPageIndex(state, data) {
          state.searchQuery.currentPage = parseInt(data);
        },
        setFilters(state, data) {
          state.searchQuery.filters = data;
        },
        setFilterGroups(state, data) {
          state.searchQuery.filterGroups = data;
        },
        setShowContentType(state, data) {
          state.searchQuery.showContentType = Boolean(data);
        },
        setResults(state, results) {
          state.results = results;
        },
        setPageSize(state, size) {
          state.searchQuery.pageSize = parseInt(size);
        },
        setSearchIndex(state, index) {
          state.searchQuery.searchIndex = index;
        },
        setSettings(state, settings) {
          state.settings = settings;
        }
      },
      actions
    });
  }
}